import { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Sidebar from "../sidebar/Sidebar";

import Swal from "sweetalert2";
import "../../assets/styles/component/userManager.css";

import { check_role } from "../../controllers/helps.controller";
import { delete_whitelist, get_whitelist, post_whitelist } from "../../services/whitelist.service";
import { FormattedMessage, useIntl } from "react-intl";

const Whitelist = () => {
  const intl = useIntl();
  const [navstate, setNavstate] = useState(localStorage.getItem("nav-state") ?? true);

  if (!check_role("superadmin")) {
    window.location.replace("/404");
  }
  const [ip, setIp] = useState("");
  const [comment, setComment] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!localStorage.getItem("username-redeem")) {
      window.location.replace("/login");
    }
    document.getElementsByClassName("transfer-machine")[0].innerHTML = `<FormattedMessage id="whitelist.pageTitle" defaultMessage="Whitelist IP" />`;
    const initData = async () => {
      const data = await get_whitelist();
      if (data?.detail.length > 0) setRows(data?.detail);
      else setRows([]);
    };
    initData();
  }, []);
  const handel_register = async () => {
    if (ip === "" || comment === "") {
      return Swal.fire({
        icon: "error",
        title: <FormattedMessage id="whitelist.fillAllFields" defaultMessage="Hãy điền đầy đủ thông tin" />,
      });
    }
    const data = await post_whitelist({ ip: ip, comment: comment });
    if (data.status_code === 200) {
      Swal.fire({
        icon: "success",
        title: <FormattedMessage id="whitelist.addSuccess" defaultMessage="Thêm thành công" />,
      });
      window.location.reload();
    } else
      return Swal.fire({
        icon: "error",
        title: <FormattedMessage id="whitelist.error" defaultMessage="Lỗi" />,
      });
  };
  const handel_delete = async (ip) => {
    Swal.fire({
      icon: "question",
      title: <FormattedMessage id="whitelist.deleteIp" defaultMessage={`Xoá IP: ${ip}?`} values={{ ip }} />,
      showCancelButton: true,
      cancelButtonText: <FormattedMessage id="whitelist.cancel" defaultMessage="Hủy" />,
      showConfirmButton: true,
      confirmButtonText: <FormattedMessage id="whitelist.delete" defaultMessage="Xóa" />,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = await delete_whitelist(ip);
        if (data.status_code === 200) {
          Swal.fire({
            icon: "success",
            title: <FormattedMessage id="whitelist.deleteSuccess" defaultMessage="Xóa thành công" />,
          });
          return window.location.reload();
        } else {
          return Swal.fire({
            icon: "error",
            title: <FormattedMessage id="whitelist.error" defaultMessage="Lỗi" />,
          });
        }
      }
    });
  };

  return (
    <>
      <Sidebar setNavstate={setNavstate} navstate={navstate} />
      <div id="main" className={navstate ? "" : "main-wide"}>
        <Header setNavstate={setNavstate} navstate={navstate} title={<FormattedMessage id="whitelist.manageAccounts" defaultMessage="Quản lý tài khoản" />} />
        <div className="body-user-manage">
          <div className="register-cont">
            <div className="title-register-table title-find-code-table">
              <div className="mark"></div>
              <p className="title-text-table">
                <FormattedMessage id="whitelist.addIpTitle" defaultMessage="Thêm IP vào Whitelist" />
              </p>
            </div>
            <div className="register-form-cont">
              <div className="input-form-wrapper">
                <div className="row-input">
                  <input
                    type="text"
                    value={ip}
                    onChange={(el) => setIp(el.target.value)}
                    placeholder={intl.formatMessage({ id: 'whitelist.ipPlaceholder', defaultMessage: 'Địa chỉ IP' })}
                    autoComplete="off"
                  />
                </div>
                <div className="row-input row-register">
                  <input
                    type="text"
                    value={comment}
                    onChange={(el) => setComment(el.target.value)}
                    placeholder={intl.formatMessage({ id: 'whitelist.commentPlaceholder', defaultMessage: 'Mô tả' })}
                    autoComplete="off"
                  />
                </div>
                <div id="register-btn" className="search-icon" onClick={handel_register}>
                  <FormattedMessage id="whitelist.addButton" defaultMessage="Thêm IP" />
                </div>
              </div>
            </div>
          </div>
          <div className="list-user-cont">
            <div className="title-register-table title-find-code-table">
              <div className="mark"></div>
              <p className="title-text-table">
                <FormattedMessage id="whitelist.listTitle" defaultMessage="Danh sách IP whitelist" />
              </p>
            </div>
            <div className="find-list-user">
              <div className="row-title-find-user">
                <div className="title-user-list username-row">
                  <FormattedMessage id="whitelist.ipColumn" defaultMessage="IP" />
                </div>
                <div className="title-user-list role-row">
                  <FormattedMessage id="whitelist.commentColumn" defaultMessage="Ghi chú" />
                </div>
                <div className="title-user-list config-row">
                  <FormattedMessage id="whitelist.actionColumn" defaultMessage="Thao tác" />
                </div>
              </div>
              {rows?.length > 0 &&
                rows.map((el) => (
                  <div className="row-title-find-user" key={el._id}>
                    <div className="title-user-list username-row">{el.ip}</div>
                    <div className="title-user-list role-row">{el.comment}</div>
                    <div className="title-user-list config-row">
                      <span className="delete-whitelist" onClick={() => handel_delete(el.ip)}>
                        <FormattedMessage id="whitelist.delete" defaultMessage="xóa" />
                      </span>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Whitelist;
